
export default {
  download: 'Завантажити',
}
